import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';
import type { ExperimentalNotification } from '../__types__/ExperimentalSchema';
import { ExperimentalNotificationReadState as ReadState } from '../__types__/ExperimentalSchema';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalNotifications: ExperimentalQueries['experimentalNotifications'] = (
	_,
	{ first, cursor },
	{ network },
) => {
	const continuationToken = cursor ? `&continuationToken=${cursor}` : '';
	return fetchJSON(
		network,
		`/gateway/api/notification-log/api/experimental/notifications?category=direct&expand=content.body&limit=${first}${continuationToken}`,
		{
			cache: 'no-cache',
			headers: {
				'Content-Type': MediaType.JSON,
				'x-app-name': '@confluence/home/notifications',
				'x-app-version': '0.0.1',
			},
		},
	).then(({ notifications, continuationToken: cursor }) => ({
		cursor,
		nodes: notifications.map(transformNotification),
	}));
};

const transformNotification = ({
	id,
	readState,
	timestamp,
	content: { actors, body, entity, message, path },
}: any): ExperimentalNotification => {
	const { ari: actorAri, avatarUrl, displayName } = actors[0];
	return {
		id,
		readState: readState === 'unread' ? ReadState.UNREAD : ReadState.READ,
		timestamp,
		message,
		content: {
			title: entity.title,
			actor: {
				id: actorAri,
				avatarUrl,
				displayName,
			},
			body: body.items.find((item: any) => item.appearance === 'PRIMARY')?.document,
			iconUrl: entity.icon.url,
			link: entity.link.url,
		},
		path: path.map(({ title, link }: any) => ({
			title,
			link: link?.url,
		})),
	};
};
